import { Button } from '@material-ui/core';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';

import { BiError } from 'react-icons/bi';

const PageDetect = ({ setShowerr, showerr }: any) => {


	const handleClose = () => setShowerr(false);
	const handleShow = () => setShowerr(true);



	return (
		<div>
			<Button onClick={handleShow}>
				Launch demo modal
			</Button>
			{/* onHide={handleClose} */}
			<Modal show={showerr} >
				<div className="popup__container">
					<div className="popup__modal">
						<div className="popup__modal_header">
							<div className="popup__modal_title">
								<BiError size={50} color='red' />
								{/* <h5>Are You sure want to exit?</h5> */}
							</div>
						</div>
						<div className="popup__modal_body">
							<div className="popup__modal_text detected-error">
								We have detected that you left this web page during this test!
							</div>
						</div>
						{/* <div className="popup__modal_footer">
							<button id="button-modal-cancel" className="popup__modal_button">Cancel</button>
							<button id="button-modal-continue" className="popup__modal_button">Continue</button>
						</div> */}
					</div>
				</div>
			</Modal>
		</div>
	)
}
export default PageDetect